import { AdminsService } from "@/services/admins-service";

export class TicketMessageLike {
	public id:number = 0;
	public messageId:number = 0;
	public adminId:number = 0;

	public constructor(data:any){
		this.id = data.id;
		this.messageId = data.messageId;
		this.adminId = data.adminId;
	}

	public getAdminName():string{
		let admins = AdminsService.admins;
		for (let admin of admins){
			if (admin.id == this.adminId) {
				return admin.name.split(" ")[0];
			}
		}
		return "";
	}
}